import Input from '@/components/Common/Input';
import { Box, Paper } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function AppointmentSchedulingConfig() {
  const { control } = useFormContext();

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Input
        name='appointment_scheduling_details.cancellation_rules'
        control={control}
        label='Cancellation Rules'
        placeholder='Type Here'
        multiline
        minRows={3}
        maxRows={8}
        fullWidth
      />

      <Box mt={2}>
        <Input
          name='appointment_scheduling_details.rescheduling_rules'
          control={control}
          label='Rescheduling Rules'
          placeholder='Type Here'
          multiline
          minRows={3}
          maxRows={8}
          fullWidth
        />
      </Box>
    </Paper>
  );
}
